import { useState } from 'react'

import { Box, Text, Tooltip } from '@factorialco/deprecated-design-system'
import { CompanyAvatar } from '@factorialco/factorial-one-react/dist/experimental'
import { JoinPremiumBundleFragment } from 'generated/resources/graphql'

interface Props {
  bundle: JoinPremiumBundleFragment
}

export const PremiumBundleAvatarList = ({ bundle }: Props) => {
  const [tooltipIndex, setTooltipIndex] = useState<number | null>(null)
  // TODO: remove after joins deliver more than one product bundle, testing purposes ⬇️
  const products = [...bundle.products, ...bundle.products, ...bundle.products]

  return (
    <Box flexDirection="row" gap="s4">
      {products.map((product, index) => (
        <>
          <Tooltip.Dialog
            key={`product-avatar-tooltip-${product.id}`}
            open={tooltipIndex === index}
            attachment="top center"
            backgroundColor="grey1000"
            size="big"
            textAlign="left"
            paddingY="s6"
            paddingX="s8"
            label={
              <Box gap="s8">
                <Text.Normal size="200">{product.jobBoard.description}</Text.Normal>
                <Text.Normal size="200">{product.description}</Text.Normal>
              </Box>
            }
          >
            <Box
              onMouseEnter={() => setTooltipIndex(index)}
              onMouseLeave={() => setTooltipIndex(null)}
              border={{ all: { width: 's1', color: 'grey400', style: 'solid' } }}
              borderRadius={{ all: 'rel1000' }}
              overflowY="hidden"
              overflowX="hidden"
            >
              <CompanyAvatar name={product.name} src={product.jobBoard.logoUrl} size="medium" />
            </Box>
          </Tooltip.Dialog>
        </>
      ))}
    </Box>
  )
}
